// @ts-check
import React from "react"
import PropTypes from "prop-types"

/**
 * @typedef {Object} LabelProps
 * @property {string | undefined} htmlFor
 * @property {React.ReactNode} children
 * @property {string | undefined} className
 * @property {boolean} [bold=true]
 * @property {string | undefined} id
 */
/**
 * @param {LabelProps} props
 * @returns {JSX.Element}
 */
export default function Label({
  htmlFor,
  children,
  className,
  bold = true,
  id,
}) {
  return (
    <label
      htmlFor={htmlFor}
      id={id}
      className={`${className} ${bold && "font-semibold"} block`}
    >
      {children}
    </label>
  )
}

Label.propTypes = {
  htmlFor: PropTypes.string,
  className: PropTypes.string,
}
